export default __webpack_public_path__ + "static/media/no-user-preference.ad0579b1.png";